<template>
  <div class="feedback-header" :class="{ 'feedback-header--mounted': isMounted }">
    <div class="uk-container uk-flex uk-flex-between">
      <a
        class="feedback-header__logo"
        :class="{
          'feedback-header__logo--white': isWelcome || lastStep,
          'uk-invisible': isMobile,
        }"
        href="/"
        @click.prevent="leaveHandler"
      >
        <img data-uk-svg src="@/assets/images/logo-solveit.svg" alt="logo" />
      </a>
      <a
        class="feedback-header__cross"
        :class="{ 'feedback-header__cross--white': isWelcome || lastStep }"
        href="/"
        @click.prevent="leaveHandler"
      >
        <img data-uk-svg src="@/assets/images/cross.svg" alt="zamknij" />
      </a>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Header',
  props: {
    isWelcome: {
      type: Boolean,
      required: true,
    },
    isMounted: {
      type: Boolean,
      required: true,
    },
    isMobile: {
      type: Boolean,
      required: true,
    },
    lastStep: {
      type: Boolean,
      required: true,
    },
    firstStep: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    leaveHandler(e) {
      if (this.lastStep || this.firstStep) {
        const preloader = document.querySelector('#preloader');

        if (preloader) {
          preloader.classList.remove('hide');
          setTimeout(() => {
            window.location = e.target.href;
          }, 400);
        } else {
          window.location = e.target.href;
        }
      } else {
        this.$emit('show-leave');
      }
    },
  },
};
</script>
<style scoped lang="scss">
.feedback-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 100;
  padding: rem(28px 0);
  transition: $t-opacity;
  opacity: 0;

  @include media-min($lg) {
    padding: rem(44px 0);
  }

  &--mounted {
    opacity: 1;
  }

  &__logo::v-deep {
    svg {
      height: rem(24px);
      width: rem(106px);
      transition: $t-transform;

      color: $link;

      path {
        fill: $black;
      }

      @include media-min($lg) {
        height: rem(30px);
        width: rem(135px);
      }
    }
    @include hover {
        svg,
        path,
        rect {
          fill: $link;
        }
      }
  }

  &__cross::v-deep {
    svg {
      width: 1.438rem;
      height: 1.438rem;
      transition: $t-transform;

      @include media-min($lg) {
        width: rem(20px);
        height: rem(20px);
      }

      line {
        stroke-width: 0.1875rem;
      }
    }
  }

  &__logo--white::v-deep {
    color: $white !important;

    path {
      fill: $white !important;
    }

    @include hover {
      color: $teal !important;

      svg,
      path,
      rect {
        fill: $teal !important;
      }
    }
  }

  &__cross--white::v-deep {
    color: $white;

    @include hover {
      color: $teal;

      svg,
      path,
      rect {
        fill: $teal;
      }
    }
  }

  .uk-container {
    @include media-min($lg) {
      max-width: 100%;
    }
  }
}
</style>
